const header = document.querySelector("header");
let newvr = true;
function myFunction() {
    var x = document.getElementById("myLinks");
    if (x.style.display === "flex") {
        x.style.display = "none";
        newvr = true;
        if ($(window).scrollTop() < 150) //remove the background property so it comes transparent again (defined in your css)
        $("header").removeClass("change_color");
    } else {
        x.style.display = "flex";
        newvr = false;
        $("header").addClass("change_color");
    }
}
// header 2
$(function() {
    $(window).on("scroll", function() {
        if ($(window).scrollTop() > 150) $("header").addClass("change_color");
        else if ($(window).scrollTop() < 150 && newvr === true) //remove the background property so it comes transparent again (defined in your css)
        $("header").removeClass("change_color");
    });
});

//# sourceMappingURL=careers.5c7c7533.js.map
